import { Component, ElementRef, HostListener, Inject, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardService } from 'app/services/dashboard.service';
import { ShiftDataService } from '../shift-data-analysis/shift-data.service';
import { AlertService } from 'app/shared/alert/alert.service';

@Component({
  selector: 'app-edit-site-details',
  templateUrl: './edit-site-details.component.html',
  styleUrls: ['./edit-site-details.component.scss']
})
export class EditSiteDetailsComponent implements OnInit {
  selectedTimes:any;
  selected_time_A:any;
  pickerA:any;
  day_start_time: string = '';
  day_end_time: string = '';
  night_start_time: string = '';
  night_end_time: string = '';
  speed_limit: string = '';
  saveBtnEnable:boolean = false;
  siteDetails :any[]=[];

  constructor(
    public shiftDataService: ShiftDataService,
    public dashboardService: DashboardService,
    private alertService: AlertService,
    public dialogRef: MatDialogRef<EditSiteDetailsComponent> ,@Inject(MAT_DIALOG_DATA) public data: any) { 
      //to calculate the time in dashboard to check if user is using the application or not ,if not then logout the user
      this.dashboardService.calculateTime();
    this.day_start_time = data ? this.formatTime(data.day_start_time) : "";
    this.day_end_time = data ? this.formatTime(data.day_end_time) : "";
    this.night_start_time = data ? this.formatTime(data.night_start_time) : "";
    this.night_end_time = data ? this.formatTime(data.night_end_time) : "";
    this.speed_limit = data ? data.speed_limit : "";
    this.saveBtnEnable = (this.day_end_time === null ||  this.day_end_time === null || this.night_start_time === null || this.night_end_time === null || this.day_end_time === '' ||  this.day_end_time === '' || this.night_start_time ==='' || this.night_end_time === '') ? true : false;
    }
  
  ngOnInit(): void {
  }
  //to calculate the time in dashboard to check if user is using the application or not ,if not then logout the user
  @HostListener('window:mousemove')
  @HostListener('window:keypress')
  @HostListener('window:scroll')
  @HostListener('window:touchstart')
  resetIdleTimer() {
    this.dashboardService.reInitializeTimer();
  }
  
  formatTime(timeStr) {
    // Split the time string into its components
    let timeParts = timeStr.split(':');
    // If the hour part has only one digit, add a leading zero
    if (timeParts[0].length === 1) {
        timeParts[0] = '0' + timeParts[0];
    }
    // Join the parts back together
    return timeParts.join(':');
  }

  onCloseBtnClick(){
    this.dialogRef.close();
  }

  saveSiteDetails(){
    let siteIds :any = [];
    if(this.shiftDataService && this.shiftDataService.selectedSiteSlaData && this.shiftDataService.selectedMasterSite && 
      this.shiftDataService.selectedMasterSite.sub_sites &&
      this.shiftDataService.selectedMasterSite.sub_sites[0] && this.shiftDataService.selectedMasterSite.sub_sites[0].site_id ){
      siteIds.push(this.shiftDataService.selectedMasterSite.sub_sites[0].site_id);
      siteIds.push(this.shiftDataService.selectedMasterSite.sub_sites[1].site_id);
    }
    this.dashboardService.updateSiteInformation(this.day_start_time,this.day_end_time,this.night_start_time,this.night_end_time,this.speed_limit,siteIds).subscribe(
      (res: any) => {
        this.shiftDataService.siteSelectionEvent.emit();
      },
      (error) => {
          // this.alertService.error(error.responseStatus.statusDescription);
      }
  );
    this.dialogRef.close();    
  }

  onDayStartTimeSelected(event: any) {
    this.day_start_time = event;
    this.saveBtnEnable = (this.day_end_time === null ||  this.day_end_time === null || this.night_start_time === null || this.night_end_time === null || this.day_end_time === '' ||  this.day_end_time === '' || this.night_start_time ==='' || this.night_end_time === '') ? true : false;
  }
  onDayEndTimeSelected(event: any) {
    this.day_end_time = event;
    this.saveBtnEnable = (this.day_end_time === null ||  this.day_end_time === null || this.night_start_time === null || this.night_end_time === null || this.day_end_time === '' ||  this.day_end_time === '' || this.night_start_time ==='' || this.night_end_time === '') ? true : false;
  }
  onNightStartTimeSelected(event: any) {
    this.night_start_time = event;
    this.saveBtnEnable = (this.day_end_time === null ||  this.day_end_time === null || this.night_start_time === null || this.night_end_time === null || this.day_end_time === '' ||  this.day_end_time === '' || this.night_start_time ==='' || this.night_end_time === '') ? true : false;
  }
  onNightEndTimeSelected(event: any) {
    this.night_end_time = event;
    this.saveBtnEnable = (this.day_end_time === null ||  this.day_end_time === null || this.night_start_time === null || this.night_end_time === null || this.day_end_time === '' ||  this.day_end_time === '' || this.night_start_time ==='' || this.night_end_time === '') ? true : false;
  }
}
